<template>
  <div class="hot-rank__list">
    <slot name="btn" />
    <div class="rank-list">
      <div
        class="box"
        :class="type === 'sales' && rank.length > 10 && 'active'"
      >
        <div class="nav">
          <span v-for="item in rankTitle" :key="item">{{ item }}</span>
        </div>
        <el-scrollbar :native="false" v-if="type === 'flow'">
          <div class="visible">
            <ul class="flex">
              <li class="item" v-for="(item, index) in rank" :key="index">
                <span>{{ item.id }}</span>
                <span>{{ item.city }}</span>
                <span>{{ item.time }}</span>
                <span>{{ item.ip }}</span>
                <span>{{ item.path }}</span>
              </li>
            </ul>
          </div>
        </el-scrollbar>
        <ul class="flex" v-if="type === 'sales'">
          <li
            class="item"
            v-for="(item, index) in rank.slice(0, 10)"
            :key="index"
          >
            <span>
              <div class="top">TOP {{ index + 1 }}</div>
            </span>
            <span v-if="item.sku">
              <div class="sku">
                {{ item.sku }}
              </div>
            </span>
            <span>
              <div class="name ellipses">
                <el-tooltip
                  :content="item.name"
                  placement="bottom"
                  effect="light"
                >
                  <span> {{ item.name }}</span>
                </el-tooltip>
              </div>
            </span>
            <span>
              <div class="num">{{ item.num }}</div>
            </span>
          </li>
        </ul>
      </div>
      <div class="box" v-if="type === 'sales' && rank.length > 10">
        <div class="nav">
          <span v-for="item in rankTitle" :key="item">{{ item }}</span>
        </div>
        <ul class="flex">
          <li
            class="item"
            v-for="(item, index) in rank.slice(10, 20)"
            :key="index"
          >
            <span>
              <div class="top">TOP {{ index + 11 }}</div>
            </span>
            <span v-if="item.sku">
              <div class="sku">
                {{ item.sku }}
              </div>
            </span>
            <span>
              <div class="name ellipses">
                <el-tooltip
                  :content="item.name"
                  placement="bottom"
                  effect="light"
                >
                  <span> {{ item.name }}</span>
                </el-tooltip>
              </div>
            </span>
            <span>
              <div class="num">{{ item.num }}</div>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Rank',
  props: {
    type: {
      type: String
    },
    rank: {
      type: Array
    },
    rankTitle: {
      type: Array
    }
  }
}
</script>
<style lang="scss">
.hot-rank__list {
  padding: 4.8rem 3rem 7.3rem 5rem;
  height: calc(100% - 40px - 3.2rem);
  text-align: center;
  .switch-data__btn {
    margin-bottom: 5.3rem;
  }

  .rank-list {
    height: calc(100% - 5.3rem - 40px);
  }

  .box {
    display: inline-block;
    vertical-align: top;
    width: calc(50% - 2rem);

    &.active {
      &:nth-child(1) {
        position: relative;
        margin-right: 2rem;

        &:after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          height: 100%;
          width: 1px;
          background-color: colors('bor-main');
        }
      }
    }

    &:nth-child(2) {
      margin-left: 2rem;
    }
  }

  .nav {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
  }

  .item {
    position: relative;
    display: flex;
    justify-content: center;
    margin-bottom: 0.6rem;
    z-index: 1;
    cursor: pointer;

    &:hover {
      &:before {
        background-color: rgba(243, 243, 243, 1);
      }
    }

    &:before {
      content: '';
      position: absolute;
      width: 88%;
      height: 1.9rem;
      top: -0.4rem;
      left: 0;
      background-color: rgba(243, 243, 243, 0);
      border-radius: 1rem;
      transition: all 0.3s;
      z-index: -1;
    }
  }

  .nav span {
    font-weight: bold;
  }

  .item span,
  .nav span {
    font-size: 0.9rem;
    flex: 1;

    &:nth-child(1) {
      flex: 0.3;
    }
  }

  .flex {
    div {
      width: 2rem;
      white-space: nowrap;
      text-align: left;
      display: inline-block;
    }

    .name {
      width: 15rem;
    }

    .sku {
      width: 5rem;
    }
  }
}
</style>
